/**
 * Coming Soon リアルタイム切り替えロジック
 * 1時間以内に発売される商品のカウントダウンと表示切り替えを行う
 */
const initComingSoonCards = () => {
  const comingSoonCards = document.querySelectorAll('.js-coming-soon');

  comingSoonCards.forEach((card) => {
    const releaseDateStr = card.dataset.releaseDate;
    if (!releaseDateStr) return;

    const releaseTime = new Date(releaseDateStr).getTime();
    const updateUI = () => {
      const now = new Date().getTime();
      const diff = releaseTime - now;

      if (diff <= 0) {
        // 販売開始時刻になった場合
        card.classList.remove('js-coming-soon');
        
        // バッジの削除
        const badges = card.querySelectorAll('.js-coming-soon-badge');
        badges.forEach(badge => badge.remove());

        // 非表示要素をすべて表示
        const hiddenEls = card.querySelectorAll('.js-coming-soon-hidden');
        hiddenEls.forEach(el => el.classList.remove('js-coming-soon-hidden'));
        
        console.log(`Product released: ${card.querySelector('.card__heading')?.innerText}`);
      } else {
        // 販売開始まで残り時間がある場合はタイマーをセット（ミリ秒単位で正確に）
        // 負荷軽減のため、1時間以上ある場合はチェックをスキップ（Liquid側で処理済みのため）
        if (diff < 3605000) { 
          setTimeout(updateUI, diff);
        }
      }
    };

    updateUI();
  });
};

// DOM読み込み完了時および、Shopifyのセクション再読み込み時（エディタ対策）に対応
document.addEventListener('DOMContentLoaded', initComingSoonCards);
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initComingSoonCards);
}